"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
exports.default = (function (transparent48) { return function (data) {
    var virtual = transparent48.virtual;
    var msgId = utils_1.decToHex(virtual.msgId % 0xffff, 2);
    var frame = ['48', '4b', '08', '00', msgId.slice(0, 2), msgId.slice(2, 4)];
    var appTid = utils_1.creatArrayAndFill(64, '00');
    frame.push.apply(frame, appTid);
    frame.push.apply(frame, ['00', '00', '00', '00']);
    return frame;
}; });



// WEBPACK FOOTER //
// ./src/transparent48/encode/8.ts